// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 创建邀请链接 POST /invite-url/create */
export async function inviteUrlCreateUsingPOST(
  body: API.CreateInviteUrlReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultstring>('/invite-url/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
